<template>
	<div>
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="所属门店：">
				<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="handleStoreChange">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="会员号：">
				<el-input v-model="formInline.vipNo" placeholder="请输入会员号" clearable size="small"></el-input>
			</el-form-item>
			<el-form-item label="顾客：">
				<el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small" @change="inputChange">
					<el-option v-for="item in customerInfoList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="余额上限：">
				<el-input v-model="formInline.lessMoney" placeholder="请输入余额下限" clearable size="small"></el-input>
			</el-form-item>
			<el-form-item label="余额下限：">
				<el-input v-model="formInline.moreMoney" placeholder="请输入余额上限" clearable size="small"></el-input>
			</el-form-item>
			<el-form-item label="手机号：">
				<el-input v-model="formInline.customerPhone" placeholder="请输入手机号" clearable size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button v-if="$checkBtnPermission('/vip/manage', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-upload
					v-if="$checkBtnPermission('/vip/manage', 'import')"
					ref="uploadbatch"
					:headers="myHeaders"
					:multiple="false"
					accept=".xls, .xlsx"
					action="/api/sysConfig/Vip/ImportVipInfoExcel"
					:on-success="handleImportClick"
					:show-file-list="false"
					style="padding-left: 10px; display: inline-block"
				>
					<template #trigger>
						<el-button size="small" type="warning" icon="el-icon-upload">上传</el-button>
					</template>
				</el-upload>
			</el-form-item>
		</el-form>
		<div class="table-minheight">
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe>
				<el-table-column slot="customerInfo.gender" align="center" label="性别" min-width="90">
					<template #default="scope">
						<span v-if="scope.row.customerInfo && scope.row.customerInfo.gender == 1" class="one_1">
							{{ formatterFre(scope.row.customerInfo.gender) }}
						</span>
						<span v-if="scope.row.customerInfo && scope.row.customerInfo.gender == 0" class="one_2">
							{{ formatterFre(scope.row.customerInfo.gender) }}
						</span>
					</template>
				</el-table-column>
				<template #vipNo>
					<el-table-column align="center" label="会员卡编号" min-width="150">
						<template #default="scope">
							<el-link type="primary" @click="handleShowCardChangeHistory(scope.row)">{{ scope.row.vipNo }}</el-link>
						</template>
					</el-table-column>
				</template>
				<template #operation>
					<el-table-column align="center" label="操作" min-width="260" fixed="right">
						<template #default="scope">
							<el-button v-if="btnPermission.create" size="mini" type="primary" class="el-icon-plus" @click="handleCreateRecharge(scope.row)">充值</el-button>
							<el-button v-if="btnPermission.changeCardNo" size="mini" type="warning" class="el-icon-edit" @click="handleChangeCardNo(scope.row)">修改卡号</el-button>
							<el-button v-if="btnPermission.returnCard && scope.row.balance > 0" size="mini" type="danger" class="el-icon-view" @click="handleCardReturn(scope.row)">退卡</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<el-row :gutter="20">
				<el-col :span="12">
					<span style="display: inline-block">
						会员账户余额共：
						<a style="color: red; min-width: 40px; display: inline-block; text-align: center" v-money="totalMoney">￥{{ totalMoney }}</a>
						元。
					</span>
				</el-col>
				<el-col :span="12">
					<!-- 分页组件 -->
					<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
				</el-col>
			</el-row>
		</div>
		<!-- 会员充值 -->
		<el-dialog :visible.sync="dialogVisible" title="会员充值" width="1000px" append-to-body :close-on-click-modal="false" custom-class="recharge-dialog">
			<div class="recharge-dialog-content">
				<el-form :model="rechargeInfo" label-width="100px" size="small" class="recharge-form">
					<div class="amount-row">
						<div class="amount-item">
							<label class="amount-label">
								<span style="color: red">*</span>
								充值金额
							</label>
							<el-input v-model.number="rechargeInfo.rechargeMoney" placeholder="请输入充值金额" class="amount-input"></el-input>
						</div>
						<div class="amount-item">
							<label class="amount-label">
								<span style="color: red">*</span>
								赠送金额
							</label>
							<el-input v-model.number="rechargeInfo.bonusMoney" placeholder="请输入赠送金额" class="amount-input"></el-input>
						</div>
					</div>
					<el-form-item label="支付方式" prop="payTypes" required>
						<div class="pay-types-row">
							<div v-for="(payTypeItem, index) in rechargeInfo.payTypes" :key="payTypeItem.payTypeId" class="pay-type-item" :class="{ 'pay-type-item-active': payTypeItem.payMoney > 0 }">
								<span class="pay-type-label">{{ payTypeItem.payTypeName }}</span>
								<el-input-number v-model.number="payTypeItem.payMoney" placeholder="0.00" :min="0" :step="0.01" :precision="2" size="small" controls-position="right"></el-input-number>
								<el-input v-model="payTypeItem.payComment" placeholder="备注" clearable size="small"></el-input>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<template #footer>
				<span>
					<el-button size="small" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" size="small" :loading="isSubmitting" @click="handleSubmitVipRecharge">确认充值</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 会员退卡 -->
		<el-dialog :visible.sync="dialogReturnCardVisible" title="会员退卡" width="60%" append-to-body :close-on-click-modal="false">
			<span style="display: block; margin-bottom: 10px">
				<strong>
					<i style="color: red">*</i>
					退卡金额:
				</strong>
			</span>
			<el-input v-model.number="returnCardInfo.returnMoney" placeholder="请输入退卡金额" style="width: 100%" size="small"></el-input>
			<span style="display: block; margin-bottom: 10px"><strong>退卡备注:</strong></span>
			<el-input clearable v-model="returnCardInfo.remark" placeholder="请输入退卡备注" style="width: 100%" size="small"></el-input>
			<template #footer>
				<span>
					<el-button icon="el-icon-close" size="small" @click="dialogReturnCardVisible = false">取消</el-button>
					<el-button type="primary" icon="el-icon-finished" size="small" :loading="isSubmitting" @click="handleSubmitVipReturnCard">确认</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 修改会员卡号 -->
		<changeCardNo ref="changeCardNo" @success="getListData"></changeCardNo>
		<!-- 会员卡号修改记录弹窗 -->
		<cardChangeHistoryDialog ref="cardChangeHistoryDialog"></cardChangeHistoryDialog>
	</div>
</template>

<script>
import { GetCustomerVipPageList, SaveVipRecharge, VipReturnMoney } from "@/api/vipApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetCustomerListByStore } from "@/api/baseDataApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import changeCardNo from "@/views/vip/manage/changeCardNo.vue";
import cardChangeHistoryDialog from "@/views/vip/manage/cardChangeHistoryDialog.vue";
export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				customerKeyId: "",
				vipNo: "",
				customerPhone: "",
				lessMoney: "",
				moreMoney: ""
			},
			storeList: [],
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "70",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center",
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "100",
					align: "center",
				},
				{
					prop: "customerInfo.name",
					label: "会员名称",
					minWidth: "100",
					align: "center"
				},
				{
					slot: "customerInfo.gender",
					label: "会员性别",
					align: "center"
				},
				{
					slot: "vipNo",
					label: "会员卡编号",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "balance",
					label: "账户余额",
					align: "center",
					minWidth: "150",
					isMoney: true,
					moneyType: "income"
				},
				{
					prop: "customerInfo.phone",
					label: "会员电话",
					width: "120",
					align: "center"
				},
				{
					prop: "totalRecharge",
					label: "总充值金额",
					align: "center",
					isMoney: true,
					moneyType: "income"
				},
				{
					prop: "totalConsume",
					label: "总消费金额",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "totalBonus",
					label: "总赠送金额",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "lastBonus",
					label: "最后一次赠送金额",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "vipStateStr",
					label: "会员状态",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					align: "center"
				}
			],
			btnPermission: {
				create: false,
				changeCardNo: false,
				returnCard: false
			},
			customerInfoList: [],
			dialogVisible: false,
			isSubmitting: false,
			rechargeInfo: {
				vipKeyId: "",
				rechargeMoney: 0,
				bonusMoney: 0,
				payTypes: []
			},
			payTypeList: [],
			totalMoney: 0,
			myHeaders: {},
			dialogReturnCardVisible: false,
			returnCardInfo: {
				keyId: "",
				returnMoney: 0,
				remark: ""
			}
		};
	},
	// 注册组件
	components: {
		changeCardNo,
		cardChangeHistoryDialog
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.GetEnumConfigListByCode();
		// 按钮权限
		this.getBtnPermission();
		this.getToken();
	},
	computed: {},
	methods: {
		// 上传文档时组装token
		getToken() {
			let token = localStorage.getItem("logintoken");
			this.myHeaders = {
				Authorization: "Bearer " + token
			};
		},
		// 按钮权限
		getBtnPermission() {
			this.btnPermission.create = this.$checkBtnPermission("/vip/manage", "create");
			this.btnPermission.changeCardNo = this.$checkBtnPermission("/vip/manage", "changeCardNo");
			this.btnPermission.returnCard = this.$checkBtnPermission("/vip/manage", "returnCard");
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			var params = {
				...this.formInline,
				storeKeyId: this.formInline.storeKeyId || null,
				customerKeyId: this.formInline.customerKeyId || null
			};
			GetCustomerVipPageList(params)
				.then((res) => {
					this.totalMoney = res.totalMoney;
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.loading = false;
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 性别
		formatterFre(gender) {
			return gender == 1 ? "男" : gender == 0 ? "女" : "";
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "PayType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.payTypeList = [];
						this.rechargeInfo.payTypes = [];
						res.data.forEach((item) => {
							//充值不允许使用会员卡销支付（后端规则：充值流程不扣储值卡余额），下拉与输入行中过滤
							if (parseInt(item.code) === 5) {
								return;
							}
							var payTypeId = parseInt(item.code);
							var payTypeName = item.name;
							this.payTypeList.push({
								payTypeId: payTypeId,
								payTypeName: payTypeName
							});
							this.rechargeInfo.payTypes.push({
								payTypeId: payTypeId,
								payTypeName: payTypeName,
								payMoney: 0,
								payComment: ""
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		},
		// 充值
		handleCreateRecharge(row) {
			this.rechargeInfo.vipKeyId = row.keyId;
			this.rechargeInfo.rechargeMoney = 0;
			this.rechargeInfo.bonusMoney = 0;
			this.rechargeInfo.payTypes.forEach((item) => {
				item.payMoney = 0;
				item.payComment = "";
			});
			this.dialogVisible = true;
		},
		// 获取客户信息列表
		GetCustomerListByStore(val) {
			const paramer = {
				keyId: val
			};
			GetCustomerListByStore(paramer)
				.then((res) => {
					this.customerInfoList = [];
					if (res.code == 1) {
						this.customerInfoList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取客户信息失败!");
				});
		},
		// 提交充值
		handleSubmitVipRecharge() {
			var totalPayMoney = 0;
			var usedPayTypes = [];
			for (var i = 0; i < this.rechargeInfo.payTypes.length; i++) {
				var payTypeItem = this.rechargeInfo.payTypes[i];
				if (payTypeItem.payMoney <= 0) continue;
				var payMoney = parseFloat(payTypeItem.payMoney);
				if (isNaN(payMoney)) {
					this.$message.error("请输入有效的数字金额");
					return;
				}
				if (payMoney <= 0) {
					this.$message.error("支付金额不能小于0！");
					return;
				}
				if (payTypeItem.payTypeId == 5) {
					if (usedPayTypes.includes(payTypeItem.payTypeId)) {
						this.$message.error("会员卡销仅能支付一笔！");
						return;
					}
					usedPayTypes.push(payTypeItem.payTypeId);
				}
				payTypeItem.payMoney = parseFloat(payMoney.toFixed(2));
				totalPayMoney += payTypeItem.payMoney;
			}
			if (totalPayMoney <= 0) {
				this.$message.error("支付金额不能小于0！");
				return;
			}
			if (totalPayMoney > this.rechargeInfo.rechargeMoney) {
				this.$message.error("支付金额不能大于充值金额！");
				return;
			}
			SaveVipRecharge(this.rechargeInfo)
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "充值成功！"
						});
						this.dialogVisible = false;
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("充值失败，请稍后再试！");
				});
		},
		// 门店改变时获取客户列表
		handleStoreChange(val) {
			this.formInline.customerKeyId = "";
			if (val) {
				this.GetCustomerListByStore(val);
			} else {
				this.customerInfoList = [];
			}
		},
		// 文件上传成功的回调
		handleImportClick(event, file) {
			if (!event.data) {
				if (event.msg.includes("http")) {
					this.$message({
						type: "error",
						message: "导入的数据 部分有问题,数据已下载"
					});
					window.location.href = event.msg;
				} else {
					this.$message({
						type: "error",
						message: event.msg
					});
				}
			} else {
				this.$message({
					type: "success",
					message: "导入成功"
				});
				this.getListData();
			}
		},
		//展示退卡弹窗
		handleCardReturn(row) {
			this.returnCardInfo = {
				keyId: "",
				returnMoney: 0,
				remark: ""
			};
			this.returnCardInfo.keyId = row.keyId;
			this.dialogReturnCardVisible = true;
		},
		// 提交退卡
		handleSubmitVipReturnCard() {
			var money = parseFloat(this.returnCardInfo.returnMoney);
			if (isNaN(money) || money <= 0) {
				this.$message.error("请输入正确的退卡金额！");
				return;
			}
			this.$confirm("确认退卡吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.isSubmitting = true;
				VipReturnMoney(this.returnCardInfo)
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "退卡成功！"
							});
							this.dialogReturnCardVisible = false;
							this.getListData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("退卡失败，请稍后再试！");
					})
					.finally(() => {
						this.isSubmitting = false;
					});
			});
		},
		// 修改会员卡号
		handleChangeCardNo(row) {
			this.$refs.changeCardNo.getChangeDialog(row);
		},
		// 查看会员卡号修改记录
		handleShowCardChangeHistory(row) {
			this.$refs.cardChangeHistoryDialog.getHistoryDialog(row);
		}
	}
};
</script>

<style scoped>
.one_1 {
	padding: 2px 20px;
	background: #e6f7ff;
	border: 1px solid #6acaf3;
	color: #56bbfd;
	border-radius: 2px;
}

.one_2 {
	padding: 2px 20px;
	background: #fcd4ff;
	border: 1px solid #dfbce2;
	color: #ea7cff;
	border-radius: 2px;
}

.pay-types-container {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.pay-type-row {
	display: flex;
	align-items: center;
	padding: 8px 12px;
	background: #f9f9f9;
	border-radius: 4px;
}

.pay-type-name {
	width: 80px;
	font-weight: 500;
	color: #333;
}

.recharge-dialog {
	.el-dialog__body {
		padding-top: 15px;
		padding-bottom: 10px;
		max-height: 60vh;
		overflow-y: auto;
	}
}

.recharge-dialog-content {
	width: 100%;
}

.recharge-form {
	.el-form-item {
		margin-bottom: 18px;
	}
}

.amount-row {
	display: flex;
	gap: 40px;
	margin-bottom: 20px;
}

.amount-item {
	flex: 1;
	display: flex;
	align-items: center;
	gap: 15px;
}

.amount-label {
	width: 100px;
	font-weight: 600;
	color: #303133;
	font-size: 14px;
	flex-shrink: 0;
}

.amount-input {
	flex: 1;
	min-width: 200px;
}

.pay-types-horizontal {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.pay-types-row {
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
}

.pay-type-item {
	display: flex;
	align-items: center;
	padding: 10px 15px;
	background: #fafafa;
	border-radius: 6px;
	border: 1px solid #ebeef5;
	transition: all 0.3s ease;
	gap: 15px;
	width: calc(50% - 7.5px);
	box-sizing: border-box;

	&:hover {
		border-color: #409eff;
		background: #f0f9ff;
	}

	&-active {
		border-color: #409eff;
		background: #f0f9ff;
		box-shadow: 0 2px 8px 0 rgba(64, 158, 255, 0.15);
	}
}

.pay-type-label {
	width: 100px;
	font-weight: 600;
	color: #303133;
	font-size: 14px;
	flex-shrink: 0;
}

.pay-types-row .el-input-number {
	width: 140px;
	flex-shrink: 0;
}

.pay-types-row .el-input {
	flex: 1;
	min-width: 100px;
}
</style>
